import { LookupValues, SearchFunc, SearchMode } from '../redux/types/ui'
import { BrandSearchMode, Lineage, ProductType, ProductTypeEnumIndexes } from '../types'

export interface LookupRequest {
  // Lookup request, ready to be sent over the wire
  // Most fields are optional, because they either are so or have default values
  // Compare with backend `SearchRequest` dataclass in `janepos/api/data.py`
  name?: string
  name_mode?: string
  brand?: string
  brand_mode?: string
  brand_subtype?: string
  product_type?: ProductType | ProductTypeEnumIndexes | ''
  product_subtype?: string
  no_amount?: boolean
  no_lineage?: boolean
  no_brand_subtype?: boolean
  no_product_subtype?: boolean
  no_dosage?: boolean
  dosage?: string
  strain?: string
  lineage?: Lineage | '' | 'Not Set'
  amount?: string
  limit: number
  strict?: boolean
  mode?: SearchMode
  include_removed?: 'all'
  search_func?: SearchFunc
  search_func_version?: number
  interactive?: boolean
}

// Transforms from LookupValues into a form data object, immediately usable
// as XHR payload data, ready to be encoded and sent over the wire.
export const serializeLookupValues = (
  values: LookupValues,
  searchFunc: SearchFunc,
  brandSearchMode: BrandSearchMode = 'phonetic',
  isBatchLookupMode = false,
  enableDeepMatcher: boolean = true
) => {
  const {
    brand,
    name_mode,
    brand_mode,
    limit,
    amount,
    lineage,
    brandSubtype,
    productSubtype,
    dosage,
  } = values

  const no_amount = amount === 'Not Set'
  const no_lineage = lineage === 'Not Set'
  const no_brand_subtype = brandSubtype === 'Not Set'
  const no_product_subtype = productSubtype === 'Not Set'
  const no_dosage = dosage === 'Not Set'
  const form: LookupRequest = {
    name_mode,
    brand_mode,
    limit: limit || 10,
    no_amount,
    no_lineage,
    no_brand_subtype,
    no_product_subtype,
    no_dosage,
  }

  if (values.name) {
    form.name = values.name
  }

  if (brand) {
    if (brand === 'Not Set') {
      values.brand_mode = 'none'
    } else {
      form.brand = brand
    }
  }

  if (brandSubtype && !no_brand_subtype) {
    form.brand_subtype = brandSubtype
  }
  if (lineage && !no_lineage) {
    form.lineage = lineage
  }
  if (values.productType) {
    form.product_type = values.productType
    if (productSubtype && !no_product_subtype) {
      form.product_subtype = productSubtype
    }
  }
  if (amount && !no_amount) {
    form.amount = amount
  }
  if (dosage && !no_dosage) {
    form.dosage = dosage
  }

  if (values.twoPassSearch) {
    form.strict = false
  }
  if (values.includeRemoved) {
    form.include_removed = 'all'
  }

  if (searchFunc !== 'sql') {
    form.search_func = searchFunc
  }

  if (isBatchLookupMode || values.aliasMode) {
    form.search_func_version = 1
    if (form.brand_mode === 'strict' || form.brand_mode === 'contains') {
      form.brand_mode = 'phonetic'
    }
  }

  if (enableDeepMatcher) {
    form.interactive = true
  }

  return form
}
